module.exports = __webpack_public_path__ + "static/media/FL_BNobleM_es.4bd981fa.png";